import { DetailsClickstreamPageNameDetailed, INFOSITE_PAGE_EG_CLICKSTREAM_NAME, InfositePageName } from 'src/common/constants/pages';
import { PackageType } from 'src/common/models/multi-item/multi-item-types';

export const getPageData = (packageType?: PackageType) => {
  if (!packageType) {
    return {
      navigationId: 'hotel',
      clickstreamPageName: INFOSITE_PAGE_EG_CLICKSTREAM_NAME,
      clickstreamPageNameDetailed: DetailsClickstreamPageNameDetailed.SA,
    };
  }

  const pageName = InfositePageName[packageType];
  const pageId = `${pageName},P,30`;

  return {
    pageName,
    pageId,
    navigationId: 'package',
    clickstreamPageName: INFOSITE_PAGE_EG_CLICKSTREAM_NAME,
    clickstreamPageNameDetailed: DetailsClickstreamPageNameDetailed[packageType],
  };
};
